import en from './languages/en'
import tr from './languages/tr'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

export default function initLanguages() {
  i18n.use(initReactI18next).init({
    resources: {
      en: {
        translation: en,
      },
      tr: {
        translation: tr,
      },
    },
    lng: 'tr',
    fallbackLng: 'tr',

    interpolation: {
      escapeValue: false,
    },
  })
}
